import React, { useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { HydraTable, Heading, TextFilter } from "@peracto/peracto-ui";
import { GET_LIST, useClient } from "@peracto/client";
import { parseISO } from "date-fns";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

export const SessionList = () => {
  const [selectedColumns, onSelectColumn] = useState({});

  const { client } = useClient();

  const columns = useMemo(
    () => [
      {
        Header: "Order Screen Session ID",
        accessor: "orderScreenSessionId",
        Filter: (props) => (
          <TextFilter label="Order Screen Session ID" {...props} />
        ),
        Cell: (row) => <span className="font-normal">{row.cell.value}</span>,
        selectable: false,
      },
      {
        Header: "License Plate",
        accessor: "licensePlate",
        Filter: (props) => <TextFilter label="License Plate" {...props} />,
        Cell: (row) => <span className="font-normal">{row.cell.value}</span>,
        selectable: false,
      },
      {
        Header: "VIN",
        accessor: "vin",
        Filter: (props) => <TextFilter label="VIN" {...props} />,
        Cell: (row) => <span className="font-normal">{row.cell.value}</span>,
        selectable: false,
      },
      {
        Header: "Created",
        accessor: "createdAt",
        Cell: (row) => (
          <span className="font-normal">
            {row.cell.value
              ? dayjs(parseISO(row.cell.value)).format("DD MMM YYYY HH:mm:ss")
              : ""}
          </span>
        ),
        selectable: false,
        disableSorting: true,
      },
      {
        Header: "Action",
        selectable: false,
        Cell: (row) => {
          return (
            <Link to={row.row.original["@id"]}>
              <button className="mr-2 btn btn-primary">View</button>
            </Link>
          );
        },
        disableSorting: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onFetchData = (options) =>
    client(GET_LIST, "bosch-session-logs", options);

  return (
    <>
      <Helmet>
        <title>Bosch Sessions | Peracto</title>
      </Helmet>
      <Heading name="Bosch Sessions" />

      <div className="row">
        <div className="col">
          <div className="card card--transparent">
            <div className="card-body">
              <HydraTable
                columns={columns}
                selectedColumns={selectedColumns}
                onFetchData={onFetchData}
                onSelectColumn={onSelectColumn}
                defaultFilters={{
                  orderScreenSessionId: "",
                  licensePlate: "",
                  vin: "",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
